import React from "react";
import { useNavigate } from "react-router-dom";
import { MdKeyboardDoubleArrowRight } from "react-icons/md";

function RecentPatients({ patients = [], isLoading, isSuccess }) {
  const navigate = useNavigate();

  return (
    <div
      className="card"
      style={{ maxHeight: "500px", display: "flex", flexDirection: "column" }}
    >
      {/* Header */}
      <div style={{ flex: "0 0 auto" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <p style={{ color: "#f97316" }}>Recent Patients</p>
          {patients.length > 0 && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                fontSize: "14px",
                color: "#2BC155",
                cursor: "pointer",
              }}
              onClick={() => navigate("/ClinicPatients")}
            >
              View <MdKeyboardDoubleArrowRight />
            </div>
          )}
        </div>
      </div>

      {/* Scrollable list */}
      <div
        style={{ flex: "1 1 auto", overflowY: "auto", marginTop: "10px" }}
        className="hide-scrollbar"
      >
        {isLoading && (
          <div className="flex justify-center items-center h-full py-10">
            <p className="text-gray-400">Loading recent patients...</p>
          </div>
        )}

        {isSuccess && patients.length === 0 && (
          <div className="flex justify-center items-center h-full py-10">
            <p className="text-gray-400">No recent patients found</p>
          </div>
        )}

        {isSuccess &&
          patients.length > 0 &&
          patients.map((patient, idx) => (
            <div key={idx} className="list-item">
              <div>
                <div>{patient.fullName}</div>
                <small>ID: {patient.patientIDUniqueID}</small>
                <br />
                <small>Gender: {patient.gender}</small>
                {patient.bloodGroup && (
                  <>
                    <br />
                    <small>Blood: {patient.bloodGroup}</small>
                  </>
                )}
              </div>
              <div
                className="badge py-3"
                style={{ fontSize: "14px", fontWeight: 500 }}
              >
                {patient.age}
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}

export default RecentPatients;
